export default __webpack_public_path__ + "img/bbw/bbw5.webm";